import type {EnvironmentConfig} from './types'

export function getEnvironmentConfig(script: HTMLScriptElement): EnvironmentConfig {
  const scriptUrl = new URL(script.src)
  const scriptOrigin = scriptUrl.origin
  const scriptHostname = scriptUrl.hostname

  if (scriptHostname === 'studio.anagram.ai') {
    return {
      baseUrl: 'https://studio.anagram.ai',
      allowedOrigins: ['https://studio.anagram.ai'],
    }
  }

  if (scriptHostname === 'staging.anagram.ai') {
    return {
      baseUrl: 'https://staging.anagram.ai',
      allowedOrigins: ['https://staging.anagram.ai'],
    }
  }

  if (scriptHostname.endsWith('-anagram-ai.vercel.app')) {
    return {
      baseUrl: scriptOrigin,
      allowedOrigins: [scriptOrigin],
    }
  }

  if (scriptHostname === 'studio.anagram') {
    return {
      baseUrl: scriptOrigin,
      allowedOrigins: [scriptOrigin],
    }
  }

  if (scriptHostname === 'studio.localhost' || scriptHostname === '127.0.0.1') {
    const allowedOrigins = scriptHostname === '127.0.0.1' ? [scriptOrigin, 'https://studio.localhost'] : [scriptOrigin]

    return {
      baseUrl: scriptOrigin,
      allowedOrigins,
    }
  }

  console.warn('[Anagram] Unknown environment, using script origin:', scriptOrigin)
  return {
    baseUrl: scriptOrigin,
    allowedOrigins: [scriptOrigin],
  }
}
